<template>
    <v-dialog v-model="show" :max-width="options.width" persistent>
        <v-card class="py-2">
            <v-card-text class="pt-5 px-6 pb-2">
                <div class="d-flex align-start">
                    <div class="mr-4 mt-1">
                        <v-icon size="40" :color="options.color">
                            {{ options.icon }}
                        </v-icon>
                    </div>

                    <div class="flex-grow-1">
                        <h3 class="text-h6 font-weight-bold grey--text text--darken-4 mb-2">
                            {{ title }}
                        </h3>
                        <p class="text-body-1 grey--text text--darken-2 mb-0"
                            style="white-space: pre-line; word-break: break-word;" v-html="message"></p>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <div v-if="!options.messageOk">
                    <v-btn :color="options.color" depressed class="text-none font-weight-bold mr-1" @click="noClick">
                        Não
                    </v-btn>

                    <v-btn :color="options.color" depressed class="text-none white--text font-weight-bold"
                        @click="yesClick">
                        Sim
                    </v-btn>
                </div>

                <div v-if="options.messageOk">
                    <v-btn :color="options.color" depressed class="text-none white--text font-weight-bold"
                        @click="okClick">
                        Ok
                    </v-btn>
                </div>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ConfirmDialog',
    data: () => ({
        show: false,
        title: '',
        message: '',
        resolve: null,
        options: {
            color: 'error',
            icon: 'mdi-alert-circle-outline',
            width: 500,
            messageOk: false
        }
    }),
    methods: {
        confirm(title, message, options) {
            return this.message_impl(title, message, {
                color: 'primary',
                icon: 'mdi-help-circle-outline',
                width: 500,
                messageOk: false
            }, options);
        },
        confirm_alert(title, message, options) {
            return this.message_impl(title, message, {
                color: 'error',
                icon: 'mdi-help-circle-outline',
                width: 500,
                messageOk: false
            }, options);
        },
        alert(title, message, options) {
            return this.message_impl(title, message, {
                color: 'info',
                icon: 'mdi-information-outline',
                width: 500,
                messageOk: true
            }, options);
        },
        error(title, message, options) {
            return this.message_impl(title, message, {
                color: 'error',
                icon: 'mdi-alert-circle-outline',
                width: 500,
                messageOk: true
            }, options);
        },
        success(title, message, options) {
            return this.message_impl(title, message, {
                color: 'success',
                icon: 'check-circle-outline',
                width: 500,
                messageOk: true
            }, options);
        },
        message_impl(title, message, options_default, options) {
            this.show = true;
            this.title = title;
            this.message = message;
            this.options = Object.assign(options_default, options);

            return new Promise((resolve) => {
                this.resolve = resolve;
            });
        },
        yesClick() {
            this.show = false;
            this.resolve(true);
        },
        noClick() {
            this.show = false;
            this.resolve(false);
        },
        okClick() {
            this.show = false;
            this.resolve(true);
        }
    },
    mounted() {
        // vamos exportar os métodos para o Sistema o todo
        this.$root.$confirm = this.confirm;
        this.$root.$confirm_alert = this.confirm_alert;
        this.$root.$alert = this.alert;
        this.$root.$error = this.error;
        this.$root.$success = this.success;
    }
};
</script>